import React, { Component } from "react";
import { connect } from "react-redux";
import DashboardUser from "../Dashboard/DashboardUser";
import moment from "moment";
import { assessmentActions, questionsActions } from "../../../_actions";
import { FiSend, FiFileText, FiUsers, FiBarChart2 } from "react-icons/fi";
import { BsLightbulb } from "react-icons/bs";
import { LuThumbsUp, LuThumbsDown, LuCopy, LuCheck } from "react-icons/lu";

const getTopAndBottomAssessments = (data = [], count = 5) => {
  if (!Array.isArray(data) || data.length === 0) {
    return { top: [], bottom: [] };
  }

  return {
    top: data.slice(0, count).map(ele => ele?.dimension ?? ""),
    bottom: data.slice(-count).reverse().map(ele => ele?.dimension ?? "")
  };
};

class MyChatBot extends Component {
  constructor(props) {
    super(props);
    this.messagesEndRef = React.createRef();
    this.state = {
      pageName: "/assessment/mychatbot",
      textUser: "",
      crrTempText: "",
      isChatScreen: false,
      copied: ""
    };
  }

  componentDidMount() {
    this.props.dispatch(questionsActions.getAssessmentReport());
    this.props.dispatch(questionsActions.getAssessmenrEmployeeDetails({}));
    this.props.dispatch(assessmentActions.getChatBookmark());
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.assessment.getChatTalentAIData !==
      this.props.assessment.getChatTalentAIData ||
      prevProps.assessment.loading !== this.props.assessment.loading
    ) {
      this.scrollToBottom();
    }
  }

  scrollToBottom = () => {
    setTimeout(() => {
      this.messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 80);
  };

  setUserText = (value) => {
    this.setState({ textUser: value, isEffectCheck: false });
  };

  submitChatBot = (chatMarkIdInit) => {
    const { questions, assessment } = this.props;
    const { textUser, chatMarkId } = this.state;
    const { getAssessmentReportByEmpIDData } = questions;
    const { getAssessmentReportByTeamId_USERData } = assessment;

    if (!textUser.trim()) return;

    const { top, bottom } = getTopAndBottomAssessments(getAssessmentReportByEmpIDData);

    let teamDimensionList = []
    if (getAssessmentReportByTeamId_USERData && getAssessmentReportByTeamId_USERData.length > 0) {
      getAssessmentReportByTeamId_USERData.forEach((element) => {
        teamDimensionList.push({
          ...element,
          finalSum: (Number(element.count) * Number(element.rankSum))
        })
      })
      // AssessmentList.sort((a, b) => (a.finalSum - b.finalSum))
      teamDimensionList.sort((b, a) => (a.finalSum - b.finalSum))
    }
    const { top: topTeam, bottom: bottomTeam } = getTopAndBottomAssessments(teamDimensionList);



    this.setState({ crrTempText: textUser, textUser: "", isChatScreen: true, isEffectCheck: true });

    const finalObj = {

      chatMarkId: chatMarkIdInit,
      question: textUser.trim(),

      topList: top,
      bottomList: bottom,

      topTeam: topTeam && topTeam.length > 0 ? topTeam : [],
      bottomTeam: bottomTeam && bottomTeam.length > 0 ? bottomTeam : [],

      isTeamAvailable: teamDimensionList && teamDimensionList.length > 0 ? true : false
    }

    console.log("finalObj--xd->", finalObj)
    this.props.dispatch(assessmentActions.saveChatTalentAI(finalObj, chatMarkIdInit));
  };

  // ✅ Typing effect helper
  typeWriterEffect = (text, cb) => {
    let i = 0;
    const speed = 10;

    const interval = setInterval(() => {
      i++;
      cb(text.slice(0, i));
      if (i >= text.length) clearInterval(interval);
    }, speed);

    return () => clearInterval(interval);
  };


  onLogout = () => {
    questionsActions.assessmentSurveyLogout(this.props);
    this.props.history.push(`/assessment/surveylogin`);
  }


  handleCopy = async (msgId, text) => {
    try {
      await navigator.clipboard.writeText(text);
      this.setState({ copied: msgId });

      setTimeout(() => {
        this.setState({ copied: "" });
      }, 1500);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };


  selectChatBookMark = (chatMarkId) => {
    if (chatMarkId === "new") {
      this.props.dispatch(assessmentActions.saveChatBookmark({ "type": "new" }));
      this.setState({ chatMarkId: chatMarkId, isChatScreen: false });
    } else {
      this.props.dispatch(assessmentActions.getChatTalentAI({ chatMarkId: chatMarkId }));
      this.setState({ chatMarkId: chatMarkId });
    }
  }

  switchToAdmin = () => {
    this.props.history.push(`/assessment/overview`);
  };
  render() {
    const { assessment, questions } = this.props;
    const { textUser, crrTempText, isChatScreen, isEffectCheck, copied, chatMarkId } = this.state;
    const {
      getChatTalentAIData = [],
      loading,
      getChatBookmarkData = [],
      getAssessmentReportByTeamId_USERData = []
    } = assessment;

    const {
      getAssessmenrEmployeeDetailsData,
      getAssessmentReportByEmpIDData
    } = questions;

    const s = getChatBookmarkData;
    const chatMarkIdInit = chatMarkId && chatMarkId !== "new" ? chatMarkId : (s && s[0] && s[0]["id"] ? s[0]["id"] : "new");
    console.log("chatMarkId---main1--->", chatMarkId)
    console.log("chatMarkIdInit---main1--->", chatMarkIdInit)

    console.log("s---main1--->", s)
    console.log("s---getAssessmentReportByTeamId_USERData-x-->", getAssessmentReportByTeamId_USERData);

    const chatList = [];
    getChatTalentAIData.forEach(ele => {
      chatList.push({ id: ele.id, text: ele.question, role: "user" });
      chatList.push({ id: ele.id, text: ele.response, role: "ai" });
    });

    const { top, bottom } =
      getTopAndBottomAssessments(getAssessmentReportByEmpIDData);

    const getPeriod = () => {
      const h = moment().hour();
      if (h < 12) return "Morning";
      if (h < 17) return "Afternoon";
      if (h < 21) return "Evening";
      return "Night";
    };

    const userDetails = {
      name: getAssessmenrEmployeeDetailsData?.name ?? "",
      email: getAssessmenrEmployeeDetailsData?.email ?? "",
      period: getPeriod()
    };


    const ActionButton = ({ icon, text, active, disabled }) => {
      return (
        <button
          disabled={disabled}
          className={`flex items-center gap-2 px-6 py-3 rounded-full shadow-md border
        ${active
              ? "bg-white border-[#1976D2] text-[#1976D2]"
              : "bg-white border-[#D1D5DB] text-gray-700"
            }
        ${disabled ? "opacity-50 cursor-not-allowed" : "hover:opacity-80"}
      `}
        >
          <span className="text-lg inherit text-current">
            {icon}
          </span>
          <span className="text-sm sm:text-base font-medium text-current">
            {text}
          </span>
        </button>
      );
    };


    const ChatbotLoaderButton = () => (
      <div className="flex justify-start my-4">
        <div className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-gray-100 animate-pulse">
          <span className="text-sm text-gray-600">Avira is thinking</span>
          <span className="flex gap-1">
            <span className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce" />
            <span className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce delay-150" />
            <span className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce delay-300" />
          </span>
        </div>
      </div>
    );

    // ✅ MessageBubble with typing effect
    const MessageBubble = ({ msgId, message, isAi, scrollIndex, typeIndex }) => {
      const [displayText, setDisplayText] = React.useState(
        isAi ? "" : message.text
      );

      React.useEffect(() => {
        if (isAi && message.text) {
          return this.typeWriterEffect(message.text, setDisplayText);
        }
      }, [message.text]);

      return (
        <div className={`flex mb-6 ${isAi ? "justify-start" : "justify-end"}`}>
          {!loading && scrollIndex && <div ref={this.messagesEndRef} />}
          <div>
            <div
              className={`px-4 py-3 rounded-2xl max-w-full ${isAi
                ? "bg-white text-gray-800 rounded-tl-none"
                : "bg-gray-200 rounded-tr-none"
                }`}
            >
              <p
                className="text-lg leading-relaxed whitespace-pre-wrap"
                dangerouslySetInnerHTML={{
                  __html: (typeIndex && isEffectCheck && !loading ? displayText : message.text).replace(
                    /\*\*(.*?)\*\*/g,
                    "<strong>$1</strong>"
                  )
                }}
              />
            </div>

            <div className="flex items-center gap-1.5 mt-2 text-gray-500">
              {isAi && (
                <>
                  <button className="p-2 rounded-md hover:bg-gray-100 transition">
                    <LuThumbsUp size={18} />
                  </button>
                  <button className="p-2 rounded-md hover:bg-gray-100 transition">
                    <LuThumbsDown size={18} />
                  </button>
                  <button onClick={() => {
                    this.setState({ isEffectCheck: false });
                    this.handleCopy(msgId, message.text);
                  }} className="p-2 rounded-md hover:bg-gray-100 transition">
                    {copied === msgId ? (
                      <div className="flex items-center gap-1.5">
                        <LuCheck size={17} />
                        <span className="text-xs">Copied</span>
                      </div>
                    ) : (
                      <LuCopy size={17} />
                    )}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      );
    };

    return (
      <DashboardUser userDetails={userDetails} onLogout={this.onLogout}
        chatMarkIdInit={chatMarkIdInit} pageName={this.state.pageName} switchToAdmin={this.switchToAdmin}
        getChatBookmarkData={getChatBookmarkData} selectChatBookMark={this.selectChatBookMark}>

        {chatList.length > 0 || isChatScreen ? (
          <main className="flex flex-col h-full">
            <div className="flex-1 overflow-y-auto">
              <div className="max-w-4xl mx-auto px-4">
                {chatList.map((msg, i) => (
                  <MessageBubble
                    key={i}
                    msgId={msg.id}
                    message={msg}
                    isAi={msg.role === "ai"}
                    scrollIndex={i + 1 === chatList.length - 1}
                    typeIndex={(msg.role === "ai") && (i + 1 === chatList.length)}
                  />
                ))}

                {loading && crrTempText && (
                  <MessageBubble message={{ text: crrTempText }} isAi={false} />
                )}

                {loading && <ChatbotLoaderButton />}
                {loading && <div ref={this.messagesEndRef} />}
              </div>
            </div>

            <div className="max-w-4xl mx-auto w-full px-4 pb-4">
              <div className="relative">
                <input
                  value={textUser}
                  onChange={(e) => this.setUserText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && textUser.trim()) {
                      e.preventDefault();
                      this.submitChatBot(chatMarkIdInit);
                    }
                  }}
                  placeholder="Ask Avira"
                  className="w-full py-5 pl-6 pr-16 rounded-full shadow-lg bg-white backdrop-blur-md focus:outline-none focus:ring-2 focus:ring-[#1976D2] transition border border-[#D1D5DB] text-lg" />
                <button
                  disabled={!textUser.trim() || loading}
                  onClick={() => this.submitChatBot(chatMarkIdInit)}
                  className="cursor-pointer absolute right-2 top-1/2 -translate-y-1/2 bg-gradient-to-r from-purple-600 to-blue-500 p-3 rounded-full text-white shadow-md hover:scale-105 transition">
                  <FiSend size={24} />
                </button>
              </div>
            </div>
          </main>
        ) : (
          <div className="min-h-screen flex items-center justify-center px-4">
            <div className="w-full max-w-4xl text-left">
              <h2 className="text-xl sm:text-2xl textblack font-medium"> Hi, {userDetails.name} 👋</h2>
              <div className="mt-4 textblack flex">
                <div className="">
                  <span class="rounded-full p-4 material-symbols-outlined mr-2 text-[1.5rem] bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white">
                    auto_awesome
                  </span>
                </div>
                <div>
                  <h1 className="sm:text-2xl md:text-3xl text-xl font-bold ">
                    Avira</h1>
                  <p className="text-base font-normal">The TalentPlus AI Companion</p>
                </div>
              </div>

              {top && top.length > 0 &&
                <p className="mt-8 textblack text-sm sm:text-base leading-relaxed text-left">
                  <p className="mt-8 textblack text-sm sm:text-base leading-relaxed text-left">
                    I am your Talent Digital Coach. You can ask me about your dominant talents -{" "}
                    <span className="font-semibold">
                      {top.join(", ")}
                    </span>{" "}
                    - as well as your non-dominant talents -{" "}
                    <span className="font-semibold">
                      {bottom.join(", ")}
                    </span>
                    . For example, you can ask how to use your{" "}
                    <span className="font-semibold">
                      {top[0]}
                    </span>{" "}
                    talent effectively or how to overcome the challenges related to your
                    non-dominant{" "}
                    <span className="font-semibold">
                      {bottom[0]}
                    </span>{" "}
                    talent.
                  </p>
                </p>}

              <div className="mt-10 relative w-full">
                <input
                  type="text"
                  placeholder="Ask Avira"
                  value={textUser}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && textUser.trim()) {
                      e.preventDefault();
                      this.submitChatBot(chatMarkIdInit);
                    }
                  }}
                  onChange={(e) => this.setUserText(e.target.value)}
                  className="w-full py-5 pl-6 pr-16 rounded-full shadow-lg bg-white backdrop-blur-md focus:outline-none focus:ring-2 focus:ring-[#1976D2] transition border border-[#D1D5DB] text-lg" />
                <button onClick={() => this.submitChatBot(chatMarkIdInit)}
                  disabled={(top && top.length > 0) ? !textUser.trim() : true}
                  className="cursor-pointer absolute right-2 top-1/2 -translate-y-1/2 bg-gradient-to-r from-purple-600 to-blue-500 p-3 rounded-full text-white shadow-md hover:scale-105 transition">
                  <FiSend size={28} />
                </button>
              </div>

              <div className="mt-10 flex flex-wrap justify-center gap-4">
                <ActionButton icon={<FiFileText />} text="Explore TalentPlus" />
                <ActionButton icon={<BsLightbulb />} text="Help me Learn" active />
                <ActionButton icon={<FiUsers />} text="Talk to Experts" />
                <ActionButton icon={<FiBarChart2 />} text="Reports" />
              </div>
            </div>
          </div>
        )}
      </DashboardUser>
    );
  }
}

const mapStateToProps = (state) => ({
  questions: state.questions,
  assessment: state.assessment
});

export default connect(mapStateToProps)(MyChatBot);
